import { apiClient } from './client';
import { prepareBloodTestFilesForUpload } from '../utils/bloodTestFileResize';

/** 基準値乖離フラグ（検査結果票の L/H 等） */
export type BloodTestAbnormality = 'L' | 'H' | null;

/**
 * 値を読み取った印字位置
 * ページ左上を原点、ページ幅・高さを1とした相対座標
 * AIの推定位置のため精度は近似
 */
export type BloodTestItemBbox = {
  /** 添付ファイルの順番（0始まり、アップロード順） */
  file_index: number;
  /** ファイル内のページ番号（1始まり、画像は常に1） */
  page: number;
  x: number;
  y: number;
  w: number;
  h: number;
};

/** 解析後の1項目（補正Ca を含む） */
export type BloodTestItem = {
  key: string;
  label: string;
  value: number | null;
  unit: string | null;
  raw_text: string | null;
  note: string | null;
  abnormality: BloodTestAbnormality;
  /** 読み取り位置（特定できない場合・計算値は null） */
  bbox: BloodTestItemBbox | null;
};

/** 採血結果解析のレスポンス */
export type BloodTestResult = {
  hospital_name: string | null;
  collection_date: string | null;
  items: BloodTestItem[];
};

/**
 * 採血結果ファイル（PDF/画像、複数可）を1件としてまとめてサーバーに送り、解析結果を取得する。
 * サーバー側で Bedrock を呼び出す。DB・ストレージへの保存は行わない。
 */
export async function analyzeBloodTestFiles(files: File[]): Promise<BloodTestResult> {
  // プレビューには原本を残し、解析リクエストだけをBedrockの上限以下へ縮小する。
  const requestFiles = await prepareBloodTestFilesForUpload(files);
  const form = new FormData();
  requestFiles.forEach((f) => form.append('files', f));
  // Content-Type はブラウザに boundary 付きで設定させる（手動設定しない）。
  const res = await apiClient.post<BloodTestResult>('/api/blood-test/analyze', form);
  return res.data;
}
